import { useMediaQuery } from "@mui/material";

/**
 * The app's stylesheet switches to the mobile layout at 991px
 * (see `@media (max-width: 991px)` rules in assets/css/style.css).
 * Keep the JS breakpoint identical so the hamburger / temporary drawer
 * appear on exactly the same screens the CSS treats as mobile.
 */
export const MOBILE_LAYOUT_QUERY = "(max-width:991.98px)";

const useMobileLayout = () => useMediaQuery(MOBILE_LAYOUT_QUERY);

export default useMobileLayout;
